﻿import $ from "jquery";
import inlineContent from "inlineContent";

export default class FiconBase {
	constructor($icon, options, event) {
		if (!options.$container) {
			throw "Ficons content container is not initialized";
		}

		this.$icon = $icon;
		this.options = options;
		this.$container = options.$container;

		this.create(event);
	}
	
	static init(options) {
		options.$container = $(`#${options.ficonId}`).children(".ccs-cc-ficons-content");

		const $document = $(document);

		$document
			.off("ccsFicon.focus")
			.on("ccsFicon.focus", function (e) {
				let $target;
				if (e.action === "open") {
					$target = e.api.$section;
				} else {
					$target = e.api.$icon;

					const bound = $target[0].getBoundingClientRect();
					if (bound.top < 0 || bound.bottom > window.innerHeight) {
						return;
					}
				};

				$target.focus();
			})
			.off("ccsFicon.focusLock")
			.on("ccsFicon.focusLock", function (ficonEvent) {
				const $section = ficonEvent.api.$section;

				if (ficonEvent.action === "open") {

					$document.on("focusin.ficon", function (focusEvent) {
						const $target = $(focusEvent.target);

						if (!$target.closest(".ccs-cc-inline-ficon, .ccs-hotspots-tooltips, .ccs-fancybox-container").length) {

							if ($section.is("[data-section=hotspots]")) {
								const hotspot = $section.find(".ccs-hotspots-point-active");
								if (hotspot.length) {
									hotspot.qtip("api").tooltip.focus();
									return;
								}
							}

							$section.focus();
						}
					});
				} else {
					$document.off("focusin.ficon");
				}
			});

			if (!window.customElements) {
				$("a[data-section='augmentedreality']").removeClass("ccs-cc-ficons-item");
			}
	}

	create(event) {
		const _ = this,
			$icon = _.$icon,
			$container = _.$container,
			options = _.options;

		const sectionName = $icon.data("section");

		const o = $.extend({}, options.inlineSettings);
		o.inlineContentId = `${options.ficonId}-${sectionName}`;

		const $section = _.$section = $container.children(`[data-section='${sectionName}']`);

		$section
			.attr("id", o.inlineContentId)
			.attr("tabindex", "0")
			.addClass("ccs-initialized")
			.addClass(options.templateClass)
			.append($container.children(".ccs-cc-inline-ensure-style-loaded").clone());

		_.elementId = $section.find(".ccs-cc-inline-section").data("elementid");
		_.adjustSection(sectionName, $section);

		if (sectionName === "augmentedreality") {
			_.adjustAugmentedRealitySettings(o.augmentedReality, _.options.arQrDisplayMode);
		}

		if (sectionName === "xboxinteractivestudio") {
			_.elementContext = $section.find(".ccs-cc-inline-section").data("context");
		}

		$section.one("ccsFicon", () => {
			inlineContent(o);
			new Function($section.data("init"))();
		});
	}

	adjustSection(sectionName, $section) {
		const _ = this;

		switch (sectionName) {
			case "media":
				_.adjustMedia($section);
				break;

			case "comparison":
				_.adjustComparison($section);
				break;

			case "spin":
				_.adjustSpin($section);
				break;

			case "hotspots":
				_.adjustHotspots($section);
				break;

			case "features":
				_.adjustFeatures($section);
				break;

			case "augmentedreality":
				if (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) {
					window.addEventListener("resize", _.adjustAugmentedReality($section, _.options.aspectRatio));
				}
				_.adjustAugmentedReality($section, _.options.aspectRatio);
				break;

			case "xboxinteractivestudio":
				_.adjustXboxInteractiveStudio($section);
				break;
		}
	}

	adjustAugmentedRealitySettings(sectionOptions, displayMode) {
		if (displayMode === undefined) {
			return;
		}

		if (displayMode === "none") {
			sectionOptions.qrDisplayMode = "none";
		} else {
			sectionOptions.qrDisplayMode = "page";
		}
	}

	adjustAugmentedReality($section, aspectRatio) {
		const _ = this;
		var size =_. calculateViewerSize(aspectRatio);

		$section.css({ width: `${size.width}vw` }, { height: `${size.height}vh`});
		$section.find(".ccs-cc-inline-augmentedreality").addClass("ccs-ficon-ar-block");
	}

	adjustMedia($section) {
		$section.one("ccsGalleryLoad", function () {
			const $wrapper = $section.find(".ccs-cc-viewport-slide-wrapper[data-media-type='video']:first");

			if (!ccs_util.isMobile() && $wrapper.length) {
				$wrapper.click();

				setTimeout(() => {
					const player = $wrapper.ccsVideoPlayer("getPlayer");
					player && player.setMute(true);
				}, 0);
			}
		});
	}

	adjustComparison($section) {
		$section
			.find(".ccs-logo-ls-icon")
			.removeAttr("data-logo-icon")
			.off();
	}

	adjustFeatures($section) {

		$section.one("ccsFicon", () => {
			const $slickContainer = $section.find(".ccs-cc-fc-items");
			if (!$slickContainer.length) {
				return;
			}

			const fcWrapper = [];

			$slickContainer.on("init", e => fcWrapper.push($(e.target)));

			$section.on("ccsFicon", e => {
				let event;
				if (!fcWrapper.length) {
					return;
				}

				if (e.action === "open") {
					event = "setPosition";
				}

				if (e.action === "close") {
					event = "pause";
				}

				fcWrapper.forEach($fc => $fc.ccsSlick(event));
			});
		});
	}

	adjustXboxInteractiveStudio($section) {
	}

	triggerEvent(action) {
		const _ = this,
			$icon = _.$icon,
			$section = _.$section,
			elementId = _.elementId,
			elementContext = _.elementContext,
			options = _.options,
			open = action === "open";

		if ($icon.hasClass("ccs-cc-active") ^ !open) {
			return;
		}

		$icon.toggleClass("ccs-cc-active");

		$section.trigger({ type: "ccsFicon", action: action, api: _ });

		var clientParams = {
			ElementIds: elementId,
			Action: "feature-click",
			ActionContext: JSON.stringify({
				type: "ficon",
				action: action,
				mode: options.mode,
				mobile: ccs_util.isMobile()
			})
		};

		if (elementContext) {
			clientParams.ElementContext = JSON.stringify(elementContext);
		}

		if (open) {
			_.openTime = new Date();
		} else {
			clientParams["Qty"] = Math.round((new Date() - _.openTime) / 1000);
		}

		ccs_cc_log.dispatchEvent(options.logCall, clientParams);
	}

	open(event) { }
	close(event) { }
	update(event) { }

	adjustSpin($section) { }
	adjustHotspots($section) { }


	getDefaultAspectRatio() {
		return window.innerWidth / window.innerHeight;
	}

	getSize(s) {
		return s > 600 ? 80 : 100;
	}

	calculateViewerSize(aspectRatio) {
		var mobile = navigator.maxTouchPoints && navigator.maxTouchPoints > 0;
		const _ = this;
		var ar = aspectRatio == undefined || aspectRatio == 0 ? _. getDefaultAspectRatio() : aspectRatio;
		var $arBlock = $("div[data-elementid^='inline-content-augmentedreality']");
		var height = Math.floor($arBlock.height() / window.innerHeight * 100);
		var width = Math.floor(height / ar);

		if (mobile && window.innerWidth > window.innerHeight) {
			return { width: width, height: _.getSize(window.innerHeight) };
		}

		if (mobile) {
			return { width: _.getSize(window.innerWidth), height: height };
		}
		return { width: width, height: height }
	}
};